import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import SydSelect from '../../../../commonDesign/SydSelect'
import SydLabel from '../../../../commonDesign/SydLabel'
import { useListViewVersions } from '../../../../../api/abundanceEngine'
import { useFormattingContext } from '../../../../organisms/FormattingProvider/FormattingContext'

function VersionSelect ({ viewId, label, value, onChange, placeholder, size }) {
  const { formatter } = useFormattingContext()
  const { data: versions = [], isLoading } = useListViewVersions(viewId, { includeArchived: false })

  const versionOptions = useMemo(() => {
    if (!versions?.length) return []
    return versions.map(v => ({
      label: (
        <div className='flex gap-sm items-center pr-2'>
          {!!v.isLive && <div className='bg-primary-400 text-contrast-primary-400 px-2 py-1 rounded font-size-xs' style={{ lineHeight: '1.1em' }}>Live</div>}
          <div className='flex-1'>{v.description ?? `View ${formatter(v.modifiedDate, '@MM/DD/YY')}`}</div>
        </div>
      ),
      description: `Modified ${formatter(v.modifiedDate, '@MM/DD/YY')} by ${v.modifiedByUser || v.modifiedBy} / Id: ${v.viewVersionId}`,
      value: v.viewVersionId
    }))
  }, [formatter, versions])

  const select = (
    <SydSelect
      size={size}
      placeholder={isLoading ? 'Loading...' : (placeholder || 'Select version')}
      options={versionOptions}
      isLoading={isLoading}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      minWidth='0'
    />
  )

  if (label) {
    return (
      <SydLabel label={label}>
        {select}
      </SydLabel>
    )
  }

  return select
}

VersionSelect.propTypes = {
  viewId: PropTypes.number,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  size: PropTypes.string
}

export default VersionSelect
